// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__pVcOO","OrderButton":"BuildControls_OrderButton__wBfxL","enable":"BuildControls_enable__YTbk7"};